import React from "react";
import { Alert } from "react-bootstrap";

export default function SuccessMessage(props) {
  const { message } = props;

  if (!message || message.length === 0) {
    return null;
  }

  return <Alert bsStyle="success">{message}</Alert>;
}
